import { render, staticRenderFns } from "./PickHistoryDetail.vue?vue&type=template&id=31f19833"
import script from "./PickHistoryDetail.vue?vue&type=script&lang=js"
export * from "./PickHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports